export enum FormSuccessOperateType {
  Toast = "toast",
  Link = "link",
  Modal = "modal",
}
